import { render, staticRenderFns } from "./boxset.vue?vue&type=template&id=7fc0aefe&"
import script from "./boxset.vue?vue&type=script&lang=js&"
export * from "./boxset.vue?vue&type=script&lang=js&"
import style0 from "./boxset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports